import { useMemo } from 'react';
import { apiClient } from '../../../api/client';
import { url as apiUrl } from '../../../api';
import { COFFEE_API_BASE } from '../../coffee_card_web/api/paths';
import { useLocalCache, UseLocalCacheResult } from '../../coffee_shops/utils/swrCache';

const url = apiUrl || process.env.REACT_APP_API_BASE_URL || 'http://localhost:5001';

export interface ChainPublic {
    chainId: string;
    name: string;
    slug: string;
    logoUrl: string | null;
    brandColor: string | null;
    shopCount: number;
    totalRatings: number;
}

export function useChainPublic(chainId: string | undefined): UseLocalCacheResult<ChainPublic> {
    const key = chainId ? `coffee_chain_public_${chainId}` : null;

    const fetcher = useMemo(
        () => async () => {
            const response = await apiClient.get<ChainPublic>(
                `${url}${COFFEE_API_BASE}/chains/${chainId}/public`
            );
            return response.data;
        },
        [chainId]
    );

    return useLocalCache<ChainPublic>(key, 5 * 60 * 1000, fetcher);
}
